module.exports = __webpack_public_path__ + "img/qiye2.006fa678.png";